<script>
  import * as api from '@/utils/api'
  export default {
    name: 'select-books-form',
    data: () => ({
      error: '',
      formData: {
        formats: [],
        genres: {
          action_adventure: '0',
          biography_memoir: '0',
          fantasy: '0',
          graphic_novel: '0',
          historical_fiction: '0',
          horror: '0',
          humor: '0',
          fiction: '0',
          mystery: '0',
          non_fiction: '0',
          romance: '0',
          science_fiction: '0',
          young_adult: '0'
        },
        info: {
          first_name: '',
          last_name: '',
          email: '',
          email_confirm: '',
          phone: '',
          barcode: ''
        },
        questions: {
          favorites: ``,
          last_enjoyed: ``
        }
      },
      genreInterests: [
        {
          label: 'Action/Adventure',
          key: 'action_adventure'
        },
        {
          label: 'Biography/Memoirs',
          key: 'biography_memoir'
        },
        {
          label: 'Fantasy',
          key: 'fantasy'
        },
        {
          label: 'Graphic Novels',
          key: 'graphic_novel'
        },
        {
          label: 'Historical Fiction',
          key: 'historical_fiction'
        },
        {
          label: 'Horror',
          key: 'horror'
        },
        {
          label: 'Humor',
          key: 'humor'
        },
        {
          label: 'Literary Fiction',
          key: 'fiction'
        },
        {
          label: 'Mysteries',
          key: 'mystery'
        },
        {
          label: 'Non-Fiction',
          key: 'non_fiction'
        },
        {
          label: 'Romance',
          key: 'romance'
        },
        {
          label: 'Science Fiction',
          key: 'science_fiction'
        },
        {
          label: 'Young Adults',
          key: 'young_adult'
        }
      ],
      isLoading: false,
      isValid: true,
      mediaFormats: [
        {
          label: 'Audio CD',
          value: 'audio_cd'
        },
        {
          label: 'Audio Download',
          value: 'audio_download'
        },
        {
          label: 'Book',
          value: 'book'
        },
        {
          label: 'E-Book Download',
          value: 'book_download'
        },
        {
          label: 'Large Print',
          value: 'large_print'
        },
        {
          label: 'Movie',
          value: 'movie'
        }
      ],
      textInputs: [
        {
          key: 'first_name',
          label: 'First Name *',
          required: true,
          type: 'text'
        },
        {
          key: 'last_name',
          label: 'Last Name *',
          required: true,
          type: 'text'
        },
        {
          key: 'email',
          label: 'Email *',
          required: true,
          type: 'email'
        },
        {
          key: 'email_confirm',
          label: 'Confirm Email *',
          required: true,
          type: 'email'
        },
        {
          key: 'phone',
          label: 'Phone Number',
          required: true,
          type: 'tel'
        },
        {
          key: 'barcode',
          label: 'Library Card Barcode',
          required: false,
          type: 'text'
        }
      ]
    }),
    computed: {
      validationRules(v) {
        //need to make a method as "this" is not available in data
        return {
          email: [v => !!v || 'E-mail is required', v => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
          first_name: [v => !!v || 'First name is required'],
          last_name: [v => !!v || 'Last name is required'],
          email_confirm: [
            v => {
              return v === this.formData.info.email || 'Confirmation E-mail must match.'
            }
          ]
        }
      }
    },
    methods: {
      async onSubmit() {
        console.log('hi')
        this.isLoading = true
        this.error = null
        let res
        try {
          const isValid = this.$refs.form.validate()
          if (!isValid) throw Error('Form contains errors. Please fix and try again.')
          res = await api.post('select-books', this.formData)
          if (res?.error) {
            throw Error(res.error)
          }

          if (res?.success) {
            this.$emit('success', this.formData)
          }
        } catch (e) {
          this.isValid = false
          this.error = e?.message || typeof e === 'string' ? e : 'An unknown error has occurred. Please try again or report if the issue persists.'
        } finally {
          this.isLoading = false
        }
      }
    },
    created() {}
  }
</script>

<template>
  <v-card>
    <v-card-text>
      <v-form v-model="isValid" lazy-validation ref="form" @submit.prevent="onSubmit">
        <v-row>
          <v-col cols="12" class="py-0">
            <p class="d-flex align-center font-weight-bold primary--text text-h6 my-2"><v-icon color="primary" class="mr-2">mdi-account</v-icon> Contact Information</p>
          </v-col>
          <v-col v-for="textInput in textInputs" :key="textInput.key" cols="12" sm="6">
            <v-text-field
              v-model="formData.info[textInput.key]"
              :label="textInput.label"
              outlined
              :required="textInput.required"
              :rules="validationRules[textInput.key]"
              :type="textInput.type"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-0">
            <p class="d-flex align-center font-weight-bold primary--text text-h6 mb-2 mt-8"><v-icon color="primary" class="mr-2">mdi-multimedia</v-icon>Preferred Formats</p>
          </v-col>
          <v-col v-for="checkbox in mediaFormats" :key="checkbox.value" cols="12" sm="4" class="d-flex flex-column align-start justify-start px-4 py-1 py-md-2">
            <v-checkbox v-model="formData.formats" :label="checkbox.label" :value="checkbox.value" hide-details class="ma-0"></v-checkbox>
          </v-col>
          <v-col cols="12" class="py-0">
            <p class="d-flex align-center font-weight-bold primary--text text-h6 mb-2 mt-8"><v-icon color="primary" class="mr-2">mdi-star</v-icon>Genre Interests</p>
            <template v-for="genreInterest in genreInterests">
              <v-sheet :key="genreInterest.key" class="d-flex flex-column flex-sm-row align-start align-sm-center justify-space-between py-4 py-sm-2">
                <p class="font-weight-bold primary--text pa-0 ma-0">{{ genreInterest.label }}</p>
                <v-radio-group v-model="formData.genres[genreInterest.key]" dense hide-details row class="mt-0 text-no-wrap">
                  <v-radio label="low" value="-1"></v-radio>
                  <v-radio label="neutral" value="0"></v-radio>
                  <v-radio label="high" value="1"></v-radio>
                </v-radio-group>
              </v-sheet>
              <v-divider :key="genreInterest.key + 'd'"></v-divider>
            </template>
          </v-col>
          <v-col cols="12" md="6" class="d-flex flex-column align-start justify-start">
            <p class="d-flex align-center font-weight-bold primary--text text-h6 text-no-wrap mb-2 mt-8">
              <v-icon color="primary" class="mr-2">mdi-book-heart</v-icon>Favorite Titles and Authors
            </p>
            <v-textarea v-model="formData.questions.favorites" auto-grow full-width hide-details outlined rows="4" style="width: 100%"></v-textarea>
          </v-col>
          <v-col cols="12" md="6" class="d-flex flex-column align-start justify-start">
            <p class="d-flex align-center font-weight-bold primary--text text-h6 text-no-wrap mb-2 mt-8">
              <v-icon color="primary" class="mr-2">mdi-book-clock</v-icon>Last Enjoyed Books
            </p>
            <v-textarea v-model="formData.questions.last_enjoyed" auto-grow full-width hide-details outlined rows="4" style="width: 100%"></v-textarea>
          </v-col>

          <v-col cols="12" class="my-2">
            <v-sheet min-height="75" width="100%">
              <v-alert :value="!!error" type="error">
                {{ error }}
              </v-alert>
            </v-sheet>
          </v-col>
          <v-col cols="12" class="px-4 mt-8">
            <v-btn block color="primary" :loading="isLoading" type="submit" class="submit-btn mx-auto">SUBMIT</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<style scoped>
  >>> .v-input--selection-controls__input {
    margin-right: 2px;
  }

  .submit-btn {
    max-width: 400px;
    width: 100%;
  }
</style>
